import { dictionaryList } from "../languages";

export const replaceModuleInModulesArrayByModuleId = (
  importedModules,
  moduleIdToReplace,
  newModuleObj
) => {
  return importedModules.map((module) => {
    if (module.id === moduleIdToReplace) {
      return newModuleObj;
    }
    return module;
  });
};

export const setDictionaryValuesByParams = (
  language,
  registry,
  overrideParam
) => {
  if (!language || !registry) {
    return dictionaryList.es.default.root;
  }

  return {
    ...dictionaryList[language][registry].root,
    ...dictionaryList[language][registry]?.overrides?.[overrideParam],
  };
};
